module.exports = __webpack_public_path__ + "img/icon_aiqiy.cb90a39e.png";